import { render } from "./AnnouncementCreateEditModal.vue?vue&type=template&id=9f76e624"
import script from "./AnnouncementCreateEditModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__